export default __webpack_public_path__ + "static/media/aior4.35efe323.svg";